import { TabsDesignTokens } from '@primeuix/themes/types/tabs';

export const Tabs: TabsDesignTokens = {
  tablist: {
    background: 'transparent',
  },
  tab: {
    background: '{surface.50}',
    borderColor: '{surface.200}',
    borderWidth: '1px',
    activeColor: '{surface.900}',
    color: '{surface.700}',
    activeBorderColor: '{green.400}',
    activeBackground: '{surface.0}',
    hoverBackground: '{green.50}',
    hoverBorderColor: '{green.200}',
  },
  activeBar: {
    height: '3px',
    background: '{green.500}',
  },
  tabpanel: {

  },
  css: () => `
    .p-tab {
      border-radius: 0.5rem 0.5rem 0 0;
      font-weight: 600;
    }
    .p-tab-active {
    font-weight: 700;
    }
    .p-tabpanels {
      border-radius: 0 0.5rem 0.5rem 0.5rem;
    }
    `,
};
